// src/pages/Maestros.jsx
import React, { useEffect, useState } from 'react'
import BarraPrincipal from '../Modulos/BarraPrincipal'
import {
    Container,
    Row,
    Col,
    Card,
    CardBody
} from 'reactstrap'

import ModalAcompanantes from '../components/maestros/modals/modalAcompanantes'
import ModalInstaladores from '../components/maestros/modals/modalInstaladores'
import ModalTransportadora from '../components/maestros/modals/modalTransportadora'
import ModalRutas from '../components/maestros/modals/modalRutas'
import '../Pages/Css/modalesMaestros.css';
import ModalAlertas from '../components/maestros/modals/modalAlertas'
import ModalAdminGrupos from '../components/maestros/modals/modalAdminGrupos'
import ModalCiudades from '../components/maestros/modals/modalCiudades'
import ModalAgencias from '../components/maestros/modals/modalAgencias'
import axios from '../utils/axiosConfig'
import Swal from 'sweetalert2'
import ModalPropietarios from '../components/maestros/modals/modalPropietarios'
import ModalVehiculos from '../components/maestros/modals/modalVehiculos'

const Maestros = () => {
    const [selected, setSelected] = useState(null);
    const [bitOpen, setBitOpen] = useState(false);
    const [bitInserts, setBitInsert] = useState(false);
    const [bitEdits, setBitEdit] = useState(false);
    const [bitDeletes, setBitDelete] = useState(false);



    const maestros = [
        { id: 'nuevaTransportadora', nombre: 'Transportadoras', iconClass: 'bx bxs-truck bx-sm bx-tada-hover', pagePermission: 30 },
        { id: 'nuevaRuta', nombre: 'Rutas', iconClass: 'bx bxs-map bx-sm bx-tada-hover', pagePermission: 31 },
        { id: 'adminGroups', nombre: 'Admin. Groups', iconClass: 'bx bxs-group bx-sm bx-tada-hover', pagePermission: 32 },
        { id: 'nuevoInstalador', nombre: 'Instaladores', iconClass: 'bx bxs-wrench bx-sm bx-tada-hover', pagePermission: 33 },
        { id: 'nuevoAcompaniante', nombre: 'Acompañantes', iconClass: 'bx bxs-user-plus bx-sm bx-tada-hover', pagePermission: 34 },
        { id: 'crearAlertas', nombre: 'Alertas', iconClass: 'bx bxs-bell bx-sm bx-tada-hover', pagePermission: 35 },
        { id: 'crearCiudad', nombre: 'Ciudades', iconClass: 'bx bxs-city bx-sm bx-tada-hover', pagePermission: 36 },
        { id: 'nuevaAgencia', nombre: 'Agencias', iconClass: 'bx bxs-building bx-sm bx-tada-hover', pagePermission: 37 },
        { id: 'nuevoPropietario', nombre: 'Propietarios', iconClass: 'bx bxs-user-check bx-sm bx-tada-hover', pagePermission: 50 },
        { id: 'nuevoVehiculo', nombre: 'Vehiculos', iconClass: 'bx bxs-car-garage bx-sm bx-tada-hover', pagePermission: 51 }

    ]

    const componentMap = {
        nuevaTransportadora: <ModalTransportadora bitInserts={bitInserts} bitEdits={bitEdits} bitDeletes={bitDeletes} />,
        nuevaRuta: <ModalRutas bitInserts={bitInserts} bitEdits={bitEdits} bitDeletes={bitDeletes} />,
        nuevoInstalador: <ModalInstaladores bitInserts={bitInserts} bitEdits={bitEdits} bitDeletes={bitDeletes} />,
        nuevoAcompaniante: <ModalAcompanantes bitInserts={bitInserts} bitEdits={bitEdits} bitDeletes={bitDeletes} />,
        crearAlertas: <ModalAlertas bitInserts={bitInserts} bitEdits={bitEdits} bitDeletes={bitDeletes} />,
        adminGroups: <ModalAdminGrupos bitInserts={bitInserts} bitEdits={bitEdits} bitDeletes={bitDeletes} />,
        crearCiudad: <ModalCiudades bitInserts={bitInserts} bitEdits={bitEdits} bitDeletes={bitDeletes} />,
        nuevaAgencia: <ModalAgencias bitInserts={bitInserts} bitEdits={bitEdits} bitDeletes={bitDeletes} />,
        nuevoPropietario: <ModalPropietarios bitInserts={bitInserts} bitEdits={bitEdits} bitDeletes={bitDeletes} />,
        nuevoVehiculo: <ModalVehiculos bitInserts={bitInserts} bitEdits={bitEdits} bitDeletes={bitDeletes} />
    }

    const handleRolePage = async (page, nextId) => {
        console.log('Página seleccionada:', page);
        console.log('ID seleccionado:', nextId);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SERVER}/usuarios/getconfiguracionpagina`,
                JSON.stringify({ pagina: page }),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            );

            if (res.data?.success === false) {
                window.location.href = "/";
                return;
            }

            const cfg = res.data?.data?.[0];
            if (!cfg) return;

            setBitOpen(cfg.bitOpen);
            setBitInsert(cfg.bitInsert);
            setBitEdit(cfg.bitEdit);
            setBitDelete(cfg.bitDelete);

            if (cfg.bitOpen) {
                // tiene permiso → selecciona el maestro
                setSelected(nextId);
            } else {
                Swal.fire({
                    title: "Información",
                    text: "No tiene los permisos necesarios para acceder a esta página",
                    icon: "info",
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });
            }
        } catch (err) {
            console.error("Error al listar bit permisos:", err);
        }
    };


    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <div className="layout-page">
                    <BarraPrincipal />
                    <Container fluid className="py-4">
                        <Row className="d-flex flex-wrap g-4 justify-content-center">
                            {maestros.map(({ id, nombre, iconClass, pagePermission }) => (
                                <Col key={id} xs="6" lg="auto">
                                    <Card
                                        onClick={() => handleRolePage(pagePermission, id)}
                                        className={`card-fixed${selected === id ? ' card-selected' : ''}`}
                                        style={{ cursor: 'pointer', padding: '0.5rem' }}
                                    >
                                        <CardBody className="text-center">
                                            <i className={iconClass} style={{ fontSize: '2rem' }} />
                                            <div className="mt-2 d-none d-md-block ">
                                                <strong className="maestro-title" title={nombre}>{nombre}</strong>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                    </Container>


                    {/* CONTENEDOR Dinámico */}
                    {selected ? (
                        <Container className="py-4">
                            <div className="p-4 bg-white shadow rounded">
                                {componentMap[selected]
                                    || <p><strong>{maestros.find(m => m.id === selected).nombre}</strong> no está implementado aún.</p>
                                }
                            </div>
                        </Container>
                    ) : (
                        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
                            <div className="text-center p-4 rounded" style={{ background: '#f5f6fa', color: '#6c757d' }}>
                                <i className="bx bx-info-circle bx-lg mb-3" style={{ color: '#adb5bd' }}></i>
                                <h4 className="mb-2">Selecciona una opción</h4>
                                <p>Haz clic en una tarjeta para continuar.</p>
                            </div>
                        </Container>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Maestros
